import React from 'react'
import { Icon } from '@UILibrary/Icon'
import { Text } from '@UILibrary/Text'

import styles from './stat.module.sass'

interface StatProps {
  percentage: number
  timeframe: string
  className?: string
  reverseCheck?: boolean
}

export const Stat: React.FC<StatProps> = ({ percentage, timeframe, className, reverseCheck = false }) => {
  const isError = reverseCheck ? percentage > 0 : percentage < 0
  const displayValue = `${percentage > 0 ? `+${percentage}` : percentage}%`

  let iconName: string | undefined = undefined
  let color = isError ? 'error' : 'secondary-main'

  if (percentage == 0) {
    color = 'gray'
    iconName = 'equal-sign'
  }

  return (
    <div className={className} style={{ margin: 'auto' }}>
      <Text heading4b as="h3" colour={color} margin='none'>
        { iconName && <Icon name={iconName} size="medium" color={color} className={styles.icon} /> } {displayValue}
      </Text>

      <Text bodySmall as="p" margin='none'>
        since last {timeframe}
      </Text>
    </div>
  )
}
